<template>
  <div>
    <a-table
        :columns="columns"
        :data-source="dataSource"
        :pagination="ipagination"
        :loading="loading"
        rowKey="id"
        @change="handleTableChange">
    </a-table>
  </div>
</template>

<script>
import {getAction} from "@/api/manage";
export default {
  name: "SearchLog",
  data(){
    return{
      dataSource: [],
      columns: [
        {
          title: '关键词',
          dataIndex: 'name',
          width: '35%',
        },
        {
          title: '扣费金额',
          dataIndex: 'money',
          width: '30%',
        },
        {
          title: '搜索时间',
          dataIndex: 'time',
          width: '35%',
        },
      ],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '30', '50'],
        showTotal: (total, range) => {
          return "第" + range[0] + "至" + range[1] + "条,共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: false,
      queryParam: {},
      isorter:{
        column: 'createTime',
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
    }
  },
  created() {
    this.dataList()
  },
  methods:{
    handleTableChange(pagination, filters, sorter) {
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.dataList();
    },
    dataList(arg) {
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var param = {};
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      this.loading = true;
      getAction('/log/searchLogs', param).then(res => {
        if (res.success) {
          this.loading = false;
          this.dataSource = res.data.records;
          this.ipagination.total = res.data.total;
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
